import { createFileRoute } from '@tanstack/react-router'
import { FlightDataUploadPage } from 'pages/flightDataUpload/FlightDataUploadPage'
import {
  type FlightDataUploadPageSearchParams,
  flightDataUploadSearchParamsSchema,
} from 'routes/flightDataUpload/-searchParams'

const RouteComponent = () => {
  const { orgId, siteId, step, asset, component, flightSet, weather } =
    Route.useSearch()

  const searchParams: FlightDataUploadPageSearchParams = {
    step,
    asset,
    component,
    flightSet,
    weather,
  }

  return (
    <FlightDataUploadPage
      organizationId={orgId}
      siteId={siteId}
      searchParams={searchParams}
    />
  )
}

export const Route = createFileRoute('/flightDataUpload/')({
  component: RouteComponent,
  validateSearch: flightDataUploadSearchParamsSchema,
  staticData: {
    title: 'Flight Data Upload',
    layout: {
      showSidebar: false,
      enableScrolling: false,
    },
  },
})
